import {createContext} from 'react';

export type ReadonlyContextType =
  | {
      readonly: true;
      reason: {
        title: string;
        description: string;
      };
    }
  | {
      readonly: false;
      reason?: undefined;
    };

export const ReadonlyContext = createContext<ReadonlyContextType>({
  get readonly(): true {
    throw new Error('ReadonlyContext was not initialized');
  },
  get reason(): {title: string; description: string} {
    throw new Error('ReadonlyContext was not initialized');
  },
});
